import React, { ReactFragment } from "react";
import {
	Container,
	Header,
	SeeMoreButton,
	SeeMoreText,
	ItemsHorizontalScroll,
	ScrollInner,
	Title,
} from "./styles";

interface BaseClassProps {
	title: string;
	seeMoreAction?: () => void;
}

export const BaseClass: React.FC<BaseClassProps> = ({
	title,
	seeMoreAction,
}) => {
	return (
		<Container>
			<Header>
				<Title testID="base_class_title">{title}</Title>
				{seeMoreAction && (
					<SeeMoreButton
						onPress={seeMoreAction}
						testID="btn_see_more"
					>
						<SeeMoreText>Ver mais</SeeMoreText>
					</SeeMoreButton>
				)}
			</Header>
		</Container>
	);
};
